module.exports = __webpack_public_path__ + "media/reskin-images/img--access-individual-1c118201.jpg";